import React, { useState, forwardRef } from "react";
import Input from "../form/input/InputField";
import Label from "../form/Label";
import { EyeCloseIcon, EyeIcon } from "../../icons";

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
  errorMessage?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ label, required, errorMessage, className, ...rest }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <div>
        <Label>
          {label} {required && <span className="text-error-500">*</span>}
        </Label>
        <div className="relative">
          <Input
            type={showPassword ? "text" : "password"}
            ref={ref}
            className={className}
            {...rest}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
          >
            {showPassword ? (
              <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
            ) : (
              <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
            )}
          </span>
        </div>
        {errorMessage && (
          <p className="mt-1 text-sm text-error-500">{errorMessage}</p>
        )}
      </div>
    );
  }
);

export default PasswordInput; 